import React, { useEffect, useState } from 'react';
import Text from '../../../../../Components/Base/Text/Text';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import LinkButton from '../../../../../Components/Button/LinkButton';
import useTranslation from '../../../../../Hooks/useTranslation';
import NoEscape from '../../../../../Components/NoEscape';
import useNCZIConnectionCheck from '../../../Hooks/useNCZIConnectionCheck';

// @ts-ignore
import styles from './NCZIWizardSteps.module.scss';
import Loading from '../../../../../Components/Loading';

interface Props {
	onContinue: () => void;
}

const NCZIWizardCardConnectionCheck: React.FC<Props> = ({ onContinue }) => {
	const { t } = useTranslation();
	const [ showCardSetup, setShowCardSetup ] = useState(false);
	const { isCardConnectLogged, cardConnectReadCardError } = useNCZIConnectionCheck();
	const [ connectionError, setConnectionError ] = useState<string|undefined>(undefined);
	const [ isLoading, setIsLoading ] = useState<boolean>(false);

	const handleCheckConnection = async () => {
		setIsLoading(true);
		const error = await cardConnectReadCardError();
		if(!error) {
			setConnectionError('');
			onContinue();
		} else {
			setConnectionError(error);
		}
		setIsLoading(false);
	}

	return (
		<div className={styles.wrapper}>
			{showCardSetup ? (
				<NCZIWizardCardSetup />
			) : (
				<>
					<Text
						tx='nczi.wizardCardConnectionCheck.title'
						className={styles.title}
					/>
					<div className={styles.warning}>
						{t('nczi.wizardCardConnectionCheck.warning')}{' '}
						<LinkButton
							title='nczi.here'
							theme={Theme.BLUE}
							onClick={() => setShowCardSetup(true)}
						/>
						.
					</div>
				</>
			)}
			{isLoading && <>
				<Loading />
			</>}
			{!isLoading && <>
				<Button
					theme={isCardConnectLogged ? Theme.GREEN : Theme.DISABLED}
					onClick={handleCheckConnection}
					title='nczi.wizardCardConnectionCheck.button'
					className={styles.button}
					disabled={!isCardConnectLogged}
				/>
				{connectionError ? <div className={styles.error}>{connectionError}</div> : ''}
			</>}
		</div>
	);
};

const NCZIWizardCardSetup: React.FC = () => {
	const { t } = useTranslation();

	return (
		<>
			<Text tx='nczi.wizardCardSetup.title' className={styles.title} />
			<ol>
				<li>
					{t('nczi.wizardCardSetup.list.item1.title')}{' '}
					<ul>
						<li>
							{t('nczi.click')}{' '}
							<LinkButton
								title='nczi.here'
								theme={Theme.BLUE}
								href='https://cdn.meddi.com/distribution/md/card-connect/setup.exe'
							/>{' '}
							<NoEscape className={styles.inline}>
								{t('nczi.wizardCardSetup.list.item1.list.item1')}
							</NoEscape>
							<div>
								<img
									src='https://cdn.meddi.com/nczi/ctecka_OMNIKEY.png'
									alt='omnikey_card_reader'
								/>
							</div>
						</li>
						<li>
							{t('nczi.click')}{' '}
							<LinkButton
								title='nczi.here'
								theme={Theme.BLUE}
								href='https://cdn.meddi.com/distribution/md/card-connect/driver/GemPcCCID.exe'
							/>{' '}
							<NoEscape className={styles.inline}>
								{t('nczi.wizardCardSetup.list.item1.list.item2')}
							</NoEscape>
							<div>
								<img
									src='https://cdn.meddi.com/nczi/ctecka_Gemalto.png'
									alt='gemalto_card_reader'
								/>
							</div>
						</li>
					</ul>
				</li>
				<li>
					{t('nczi.wizardCardSetup.list.item2.title')}
					<ul>
						<li>
							{t('nczi.click')}{' '}
							<LinkButton
								title='nczi.here'
								theme={Theme.BLUE}
								href='https://cdn.meddi.com/distribution/md/card-connect/driver/SafeNet_eToken_Minidriver.exe'
							/>{' '}
							<NoEscape className={styles.inline}>
								{t('nczi.wizardCardSetup.list.item2.list.item1')}
							</NoEscape>
							<div>
								<img
									src='https://cdn.meddi.com/nczi/stvorcovy_cip.png'
									alt='safenet_card'
								/>
							</div>
						</li>
						<li>
							{t('nczi.click')}{' '}
							<LinkButton
								title='nczi.here'
								theme={Theme.BLUE}
								href='https://cdn.meddi.com/distribution/md/card-connect/driver/10.8.2164_R6_Post_GA.zip'
							/>{' '}
							<NoEscape className={styles.inline}>
								{t('nczi.wizardCardSetup.list.item2.list.item2')}
							</NoEscape>
							<div>
								<img
									src='https://cdn.meddi.com/nczi/ovalny_cip.png'
									alt='gemalto_card'
								/>
							</div>
						</li>
					</ul>
				</li>
			</ol>
		</>
	);
};

export default NCZIWizardCardConnectionCheck;
